module.exports = __webpack_public_path__ + "static/img/extend_img05.fc85f59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/extend_img05.png
// module id = G4a8
// module chunks = 1